import { render } from "./ImgDialog.vue?vue&type=template&id=6c09308b&scoped=true"
import script from "./ImgDialog.vue?vue&type=script&lang=js"
export * from "./ImgDialog.vue?vue&type=script&lang=js"

import "./ImgDialog.vue?vue&type=style&index=0&id=6c09308b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c09308b"

export default script